import {Stack} from '../../../layout/stack/stack';
import {SelectPickerGeneric} from '../../../select-picker-generic/select-picker-generic';
import {TextField} from '../../../textfield/textfield';
import {Body} from '../../../typography/body';

import {PLURAL_CYCLE_UNIT_OPTIONS, SINGULAR_CYCLE_UNIT_OPTIONS} from './consts';
import type {
    RecurrenceDueDateFormSetters,
    RecurrenceDueDateFormState,
} from './recurrence-due-date-mode-form-types';
import type {CycleUnit} from './task-custom-recurrence-popover';

interface Props {
    values: RecurrenceDueDateFormState;
    setters: RecurrenceDueDateFormSetters;
    isDisabled: boolean;
}

export function RecurrenceRepeatEveryRow(props: Props) {
    const cycleUnitOptions =
        props.values.cycleValue === 1 ? SINGULAR_CYCLE_UNIT_OPTIONS : PLURAL_CYCLE_UNIT_OPTIONS;

    return (
        <Stack spacing={8} isHorizontal={true} alignItems='center'>
            <Body size='small' color={props.isDisabled ? 'light' : 'medium'}>
                Repeat every
            </Body>
            <div style={{width: 65}}>
                <TextField
                    value={props.values.cycleValue.toString()}
                    onChange={(value) => {
                        props.setters.setCycleValue(Number(value));
                    }}
                    // @ts-expect-error
                    disabled={props.isDisabled}
                    max='99'
                    min='1'
                    size='small'
                    type='number'
                />
            </div>
            <div style={{width: 100}}>
                <SelectPickerGeneric
                    options={cycleUnitOptions}
                    value={cycleUnitOptions.find(
                        (option) => option.value === props.values.cycleUnit
                    )}
                    // @ts-expect-error
                    onChange={(value) => props.setters.setCycleUnit(value.value as CycleUnit)}
                    isDisabled={props.isDisabled}
                    menuPlacement='auto'
                />
            </div>
        </Stack>
    );
}
